import { ParameterValueOption } from '../../../api/api';

export function normalizeValueOptionValue(valueOptions: ParameterValueOption[], value: unknown): unknown {
	const matchingValue = valueOptions.find((option) => String(option.value) === String(value));
	if (matchingValue) {
		return matchingValue.value;
	}

	const matchingName = valueOptions.find((option) => String(option.name) === String(value));
	return matchingName?.value ?? value;
}

export function normalizeValueOptionValues(valueOptions: ParameterValueOption[], values: unknown[]): unknown[] {
	return values.map((value) => normalizeValueOptionValue(valueOptions, value));
}

export function hasDifferentItems(left: unknown[], right: unknown[]): boolean {
	return left.length !== right.length || left.some((item, index) => item !== right[index]);
}
